var _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoSignal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 682.667,
    height: 682.667,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "a"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.33333 0 0 -1.33333 340 533.333)",
    d: "M0 0c18.226 0 33-14.774 33-33S18.226-66 0-66s-33 14.774-33 33S-18.226 0 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c18.226 0 33-14.774 33-33S18.226-66 0-66s-33 14.774-33 33S-18.226 0 0 0",
    style: {
      fill: "#c30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(255 112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-28.686-15.969-55.684-36.863-80-62.953",
    style: {
      fill: "none",
      stroke: "#c30",
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(100 406.953)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-65.639 70.427-150.817 102.999-235.996 103h-.007c-24.148 0-48.295-2.618-71.997-7.975",
    style: {
      fill: "none",
      stroke: "#c30",
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(492 344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-34.924-11.154-67.831-31.13-96.003-59.522",
    style: {
      fill: "none",
      stroke: "#c30",
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(189 320.476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-35.61 35.88-78.762 58.318-123.997 66.499",
    style: {
      fill: "none",
      stroke: "#c30",
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(418.997 260.953)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-18.096 10.354-38.428 16.289-57.203 16.286h-1.444c-28.62.004-60.859-13.788-83.278-36",
    style: {
      fill: "none",
      stroke: "#c30",
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(313 197.714)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 472-472",
    style: {
      fill: "none",
      stroke: "#c30",
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(20 492)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSignal);
export default __webpack_public_path__ + "static/media/no-signal.84aebf30c6cd1e9b1a0852fc82cc9098.svg";
export { ForwardRef as ReactComponent };